import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { getKey } from "../../helpers/sessionKey";

const DeliveryChargeListComponent = loadable(
  () => import("../../components/DeliveryCharge/DeliveryChargeList")
);

const DeliveryChargeList = () => {
  const raw = getKey("default-branch") || '"main"';
  const defaultBranch = JSON.parse(raw);

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <StatusIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Delivery Charge
        </span>
      </div>

      <DeliveryChargeListComponent defaultBranch={defaultBranch} />
    </>
  );
};

export default DeliveryChargeList;
